import { Component, ViewChild, AfterViewInit, OnInit, OnDestroy, ChangeDetectorRef, HostListener, ElementRef } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonService, CrudComponent } from 'wire-frame';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { TagModule } from 'primeng/tag';
import { AutoCompleteModule } from "primeng/autocomplete";
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { ToasterService } from '../../../service/common/toaster.service';
import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';

import { PreConsultationService } from '../../../service/admin/pre-consultation.service';
import { PrescriptionsService} from '../../../service/admin/prescriptions.service';
import { AppointmentService } from '../../../service/admin/appointment.service';
import { ClinicService } from '../../../service/admin/clinic.service';
import { UserService } from '../../../service/admin/user.service';
import { PatientRegistrationService } from '../../../service/admin/patient-registration.service';
import { ChiefComplaintService } from '../../../service/admin/chief-complaint.service';

import { ApiService } from '../../../service/admin/api.service';
import { AiService } from '../../../service/admin/ai.service';
import { ConsultationDraftService } from '../../../service/admin/consultation-draft.service';

import { StatusBadgePipe } from '../../../status-badge.pipe';
import { AutoCapitalizeDirective } from '../../../directives/auto-capitalize.directive';
import { capitalizeClinicalTextFields, capitalizeLineStarts } from '../../../shared/clinical-text.util';
import { bindPatientSearchOverlayScroll } from '../../../shared/patient-search-overlay-scroll';
import { HotkeyHelpComponent } from '../hotkey-help/hotkey-help.component';
import {
  canOpenTextReport,
  formatTextReportCounter,
  getTextReportBody,
  getTextReportCharCount,
  getTextReportExcerpt,
  getTextReportLineCount,
  isTextReport as isTextReportFile,
  isTextReportOverLimit,
  TEXT_REPORT_MAX_LENGTH,
} from '../shared/text-report.util';

import jsPDF from 'jspdf';

@Component({
  selector: 'app-pre-consultation',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    DropdownModule,
    ToolbarModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    CrudComponent,
    EditorModule,
    ButtonModule,
    TabViewModule,
    ScrollPanelModule,
    SidebarModule,
    AutoCompleteModule,
    DialogModule,
    TooltipModule,
    StatusBadgePipe,
    AutoCapitalizeDirective,
    HotkeyHelpComponent
  ],
  providers: [ConfirmationService, CommonService, PreConsultationService, PrescriptionsService, AppointmentService, ClinicService, UserService, PatientRegistrationService, ChiefComplaintService, ApiService, ConsultationDraftService],
  templateUrl: './pre-consultation.component.html',
  styleUrls: ['./pre-consultation.component.scss']
})
export class PreConsultationComponent implements OnInit, AfterViewInit, OnDestroy {
  activeIndex = 0;
  patientIndex = 0;
  readonly reportsTabIndex = 2;
  historyTabIndex: number = 3;
  historyPageSize: number = 8;
  historyCurrentPage: number = 0;
  historyTotalRecords: number = 0;
  historyHasMore: boolean = false;
  historyLoading: boolean = false;
  historyLoadingMore: boolean = false;
  historyError: string = '';
  historyInitializedForPatientId: number = 0;
  selectedHistoryIndex: number = 0;
  private activeHistoryRequestToken: number = 0;
  totalPrice = 0;
  quantity = 0;
  unitPrice = 0;

  fromDate: string | null = null;
  toDate: string | null = null;
  filteredRecords: any[] = [];
  allRecords: any[] = [];


  selectedIndex: number | string = 'today';
  uploadsByDate: { date: Date, files: any[] }[] = [];

  pdfSrc: SafeResourceUrl | null = null;
  aiPlan: string = '';

  public preconsultationList: any[] = [];
  public editRecord: any = null;

  public patientsList: any[] = [];
  public prescriptionsList: any[] = [];
  public doctorsList = [];
  public appointmentsList = [];
  public clinicsList = [];
  public queue: any[] = [];
  public queueTypeFilter: 'all' | 'new' | 'follow_up' = 'all';
  public queueModeFilter: 'all' | 'OPD' | 'COURIER' | 'NRI' | 'MC' = 'all';
  public isQueueRefreshing: boolean = false;
  public nextPatientIndex: number = -1;
  public clinicId: number = 0; // Default clinic ID
  public doctorId: number = 0; // Default clinic ID
  // public selectedDate: string = new Date().toISOString().slice(0, 10);
  public selectedDate = new Date(Date.now() + 19800000).toISOString().slice(0, 10);
  public selectedPatient: any;
  public isPatientVisible: boolean = false;
  public patientSelectedFromSearch = false;
  public searchVisitType: 'auto' | 'new' | 'follow_up' = 'auto';
  public searchVisitTypeOptions: { label: string; value: 'auto' | 'new' | 'follow_up' }[] = [
    { label: 'Auto', value: 'auto' },
    { label: 'New', value: 'new' },
    { label: 'Follow Up', value: 'follow_up' }
  ];
  private unbindPatientSearchOverlayScroll: (() => void) | null = null;
  public pendingFiles: File[] = [];
  readonly reportUploadMaxMb = PrescriptionsService.REPORT_UPLOAD_MAX_MB;
  public reportTextTitle: string = '';
  public reportTextContent: string = '';
  public isSavingTextReport: boolean = false;
  public textReportViewerVisible = false;
  public textReportViewerLoading = false;
  public viewingTextReport: any = null;
  readonly textReportMaxLength = TEXT_REPORT_MAX_LENGTH;
  public reportsSidebarWidth = 300;
  public reportsSplitterDragging = false;
  private readonly reportsSidebarMinWidth = 260;
  private readonly reportsSidebarMaxWidth = 520;
  private readonly reportsGalleryMinWidth = 280;
  private readonly reportsSplitterWidth = 8;
  private readonly reportsSidebarStorageKey = 'precon_reports_sidebar_width';
  private reportsResizeStartX = 0;
  private reportsResizeStartWidth = 0;
  public queueSidebarWidth = 380;
  public queueSplitterDragging = false;
  private readonly queueSidebarMinWidth = 280;
  private readonly queueSidebarMaxWidth = 560;
  private readonly mainPanelMinWidth = 480;
  private readonly queueSplitterWidth = 8;
  private readonly queueSidebarStorageKey = 'precon_queue_sidebar_width';
  private queueResizeStartX = 0;
  private queueResizeStartWidth = 0;
  @ViewChild('reportsLayout') reportsLayoutRef?: ElementRef<HTMLElement>;
  @ViewChild('pcShell') pcShellRef?: ElementRef<HTMLElement>;
  public doctorNotesDialogVisible: boolean = false;
  public doctorNotesTab: 'notes' | 'instructions' = 'notes';
  public doctorNotesHistory: Array<{ date: string; notes: string }> = [];
  public latestDoctorNote: string = '';
  public latestDoctorNoteDate: string = '';
  public specialInstructionsHistory: Array<{ date: string; notes: string }> = [];
  public latestSpecialInstruction: string = '';
  public latestSpecialInstructionDate: string = '';
  private draftAutosaveTimer: ReturnType<typeof setInterval> | null = null;
  private isDraftAutosavePausedUntilChange = false;
  private isDraftAutosaveSuspended = false;
  private queueRefreshTimer: ReturnType<typeof setInterval> | null = null;
  private hotkeySidebarEl: Element | null = null;
  private openSearchListener?: () => void;
  public draftSaveState: 'idle' | 'saving' | 'saved' | 'error' | 'cleared' = 'idle';
  public draftSaveLabel: string = 'Draft autosave is active.';
  public canClearDraftFlag: boolean = false;
  // public complaintTags: string[] = [];

  public patient: any = {
    id: 0,  // number: Unique ID
    first_name: '',  
    middle_name: '',  
    last_name: '',  
    primary_contact: '',  // string: Phone number
    secondary_contact: '',  // string: Phone number
    age: 0,
    blood_group: '',
    gender: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    marital_status: '',
    is_free: false,     // number: Age in years  // boolean: true = free visit,     // string: Courier-related info
    scanned_card: null as File | null, // File upload (can be null or File)

    visit_date: new Date(),

    // Date of first visit
    first_visit:  '', // Date of first visit
    patient_number: '',
    is_courier: 'OPD',
  };

  public preconsultation: any = {
      appointment_id: 0,
      allergies: '',
      current_medications: '',
      personal_family_history: '',
      surgical_history: '',
      blood_pressure: '',
      pulse_rate: '',
      temperature: '',
      weight: '',
      height: '',
      fasting_blood_sugar: '',
      blood_oxygen: '',
      runny_nose: '',
      cough: '',
      chief_complaints: '',
      notes: '',
      is_courier: 'OPD'
      // chief_complaints: '',
  };
  public preconsultationModeOptions = [
    { label: 'OPD', value: 'OPD' },
    { label: 'Courier', value: 'COURIER' },
    { label: 'NRI', value: 'NRI' }
  ];

  public closeFormEvent = false;
  public openDeletePopup: any = null;
  public activeMenu = 'personal';

  isLoading = false;

  // chief complaints fields
  public complaintTags: string[] = [];
  public complaintInput: string = '';
  public allComplaints: string[] = [];
  public filteredComplaints: string[] = [];

  // private apiUrl = "https://test.drshaileshsancheti.com/api";
  private apiUrl: string | undefined;

  constructor(
    public common: CommonService,
    private toast: ToasterService,
    private confirmationService: ConfirmationService,
    private preConsultationService: PreConsultationService,
    private sanitizer: DomSanitizer,   // ✅ add here
    private prescriptionsService: PrescriptionsService,
    private appointmentService: AppointmentService,
    private clinicService: ClinicService,
    private userService: UserService,
    private http: HttpClient, 
    private cdr: ChangeDetectorRef,
    private patientRegistrationService: PatientRegistrationService,
    private chiefComplaintService: ChiefComplaintService,
    private apiService: ApiService,
    private aiService: AiService,
    private statusBadgePipe: StatusBadgePipe,
    private consultationDraftService: ConsultationDraftService
  ) {
    this.apiUrl = this.apiService.getBaseUrl();

    this.common.breadCrum = {
      title: 'Pre Consultation',
      icon: 'user',
      list: ['Pre Consultation'],
    };

    this.common.setCrudTableHeaders([
      { title: 'Blood Pressure', val: 'bp', id: 'id', showColumn: true, filterColmn: true, order: 'asc', type: 'string' },
      { title: 'Pulse Rate', val: 'pulseRate', id: 'id', showColumn: true, filterColmn: true, order: 'asc', type: 'number' },
    ]);

    this.common.setCrudActions([
      { title: '', icon: 'pi-pencil', classArr: 'me-2', tooltip: 'Update preconsultation' },
      { title: '', icon: 'pi-trash', tooltip: 'Delete preconsultation' },
    ]);
  }

  ngOnInit() {
    this.restoreQueueSidebarWidth();
    this.restoreReportsSidebarWidth();
    this.startDraftAutosave();
    this.loadQueue();
    this.getChiefComplaints();
    this.refreshDraftAvailability();
    this.aiService.loadStatus().subscribe();

    const badge = this.statusBadgePipe.transform('doctor');

    this.queueRefreshTimer = setInterval(() => {
      if (this.common.getLoggedInUser().type === 'assistant_doctor') {
        this.loadQueue();
        this.getChiefComplaints();
      }
    }, 20000);
  }

  ngAfterViewInit() {
    this.hotkeySidebarEl = document.querySelector('[data-hotkey="patient-search"]');
    this.openSearchListener = () => this.openPatientSearch();
    this.hotkeySidebarEl?.addEventListener('open-search', this.openSearchListener);
  }

  ngOnDestroy() {
    if (this.draftAutosaveTimer) {
      clearInterval(this.draftAutosaveTimer);
      this.draftAutosaveTimer = null;
    }
    if (this.queueRefreshTimer) {
      clearInterval(this.queueRefreshTimer);
      this.queueRefreshTimer = null;
    }
    if (this.hotkeySidebarEl && this.openSearchListener) {
      this.hotkeySidebarEl.removeEventListener('open-search', this.openSearchListener);
    }
    this.openSearchListener = undefined;
    this.hotkeySidebarEl = null;
    this.onPatientSearchOverlayHide();
    this.stopReportsResize();
    this.stopQueueResize();
  }

  private restoreQueueSidebarWidth(): void {
    const stored = Number(localStorage.getItem(this.queueSidebarStorageKey));
    if (Number.isFinite(stored) && stored > 0) {
      this.queueSidebarWidth = this.clampQueueSidebarWidth(stored);
      return;
    }

    this.queueSidebarWidth = this.clampQueueSidebarWidth(380);
  }

  private clampQueueSidebarWidth(width: number, shellWidth?: number): number {
    const containerWidth = shellWidth ?? this.pcShellRef?.nativeElement?.clientWidth ?? window.innerWidth;
    const maxByLayout = containerWidth > 0
      ? containerWidth - this.mainPanelMinWidth - this.queueSplitterWidth
      : this.queueSidebarMaxWidth;
    const maxWidth = Math.max(
      this.queueSidebarMinWidth,
      Math.min(this.queueSidebarMaxWidth, maxByLayout || this.queueSidebarMaxWidth)
    );
    return Math.max(this.queueSidebarMinWidth, Math.min(maxWidth, Math.round(width)));
  }

  startQueueResize(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.queueSplitterDragging = true;
    this.queueResizeStartX = event.clientX;
    this.queueResizeStartWidth = this.queueSidebarWidth;
    document.body.classList.add('pc-queue-resizing');
  }

  private stopQueueResize(): void {
    if (!this.queueSplitterDragging) {
      document.body.classList.remove('pc-queue-resizing');
      return;
    }
    this.queueSplitterDragging = false;
    document.body.classList.remove('pc-queue-resizing');
  }

  private restoreReportsSidebarWidth(): void {
    const stored = Number(localStorage.getItem(this.reportsSidebarStorageKey));
    if (!Number.isFinite(stored)) return;
    this.reportsSidebarWidth = this.clampReportsSidebarWidth(stored);
  }

  private clampReportsSidebarWidth(width: number, layoutWidth?: number): number {
    const containerWidth = layoutWidth ?? this.reportsLayoutRef?.nativeElement?.clientWidth ?? 0;
    const maxByLayout = containerWidth > 0
      ? containerWidth - this.reportsGalleryMinWidth - this.reportsSplitterWidth
      : this.reportsSidebarMaxWidth;
    const maxWidth = Math.max(
      this.reportsSidebarMinWidth,
      Math.min(this.reportsSidebarMaxWidth, maxByLayout || this.reportsSidebarMaxWidth)
    );
    return Math.max(this.reportsSidebarMinWidth, Math.min(maxWidth, Math.round(width)));
  }

  startReportsResize(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.reportsSplitterDragging = true;
    this.reportsResizeStartX = event.clientX;
    this.reportsResizeStartWidth = this.reportsSidebarWidth;
    document.body.classList.add('pc-reports-resizing');
  }

  @HostListener('document:mousemove', ['$event'])
  onDocumentMouseMove(event: MouseEvent): void {
    if (this.reportsSplitterDragging) {
      event.preventDefault();
      const delta = event.clientX - this.reportsResizeStartX;
      this.reportsSidebarWidth = this.clampReportsSidebarWidth(this.reportsResizeStartWidth + delta);
      return;
    }

    if (!this.queueSplitterDragging) return;
    event.preventDefault();
    const delta = event.clientX - this.queueResizeStartX;
    this.queueSidebarWidth = this.clampQueueSidebarWidth(this.queueResizeStartWidth + delta);
  }

  @HostListener('document:mouseup')
  onDocumentMouseUp(): void {
    if (this.reportsSplitterDragging) {
      this.stopReportsResize();
      localStorage.setItem(this.reportsSidebarStorageKey, String(this.reportsSidebarWidth));
    }

    if (this.queueSplitterDragging) {
      this.stopQueueResize();
      localStorage.setItem(this.queueSidebarStorageKey, String(this.queueSidebarWidth));
    }
  }

  @HostListener('window:resize')
  onShellLayoutResize(): void {
    this.queueSidebarWidth = this.clampQueueSidebarWidth(this.queueSidebarWidth);
    this.reportsSidebarWidth = this.clampReportsSidebarWidth(this.reportsSidebarWidth);
  }

  private stopReportsResize(): void {
    if (!this.reportsSplitterDragging) {
      document.body.classList.remove('pc-reports-resizing');
      return;
    }
    this.reportsSplitterDragging = false;
    document.body.classList.remove('pc-reports-resizing');
  }

  private startDraftAutosave() {
    if (this.draftAutosaveTimer) clearInterval(this.draftAutosaveTimer);
    this.draftAutosaveTimer = setInterval(() => {
      if (this.isDraftAutosaveSuspended) return;
      this.saveDraftSnapshot();
    }, 10000);
  }

  @HostListener('input', ['$event'])
  onDraftFormInput(event: Event) {
    if (!this.isDraftAutosavePausedUntilChange) return;
    const target = event.target as HTMLElement | null;
    if (target?.matches('input, textarea, select')) {
      this.isDraftAutosavePausedUntilChange = false;
    }
  }

  openQueueSidebar() {
    this.isPatientVisible = true;
    this.patientIndex = 0;
    this.loadQueue();
  }

  openPatientSearch() {
    this.isPatientVisible = true;
    this.patientIndex = 1;

    setTimeout(() => {
      const input = document.querySelector(
        'p-autoComplete input'
      ) as HTMLInputElement;

      input?.focus();
    }, 300);
  }

  getPreConsultation() {
    this.preConsultationService.getpreconsultation().subscribe((res: any) => {
      this.preconsultationList = res.data;
    });
  }

  onCardUpload(event: any) {
    const file = event.target.files[0];
    this.preconsultation.scanned_card = file ?? null;
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => { this.closeFormEvent = false; }, 1);
  }

  clearForm() {
    this.searchVisitType = 'auto';
    this.patient = {
      id: 0,  // number: Unique ID
      first_name: '',  
      middle_name: '',  
      last_name: '',  
      primary_contact: '',  // string: Phone number
      secondary_contact: '',  // string: Phone number
      age: 0,
      blood_group: '',
      gender: '',
      address: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      marital_status: '',
      is_free: false,     // number: Age in years  // boolean: true = free visit,     // string: Courier-related info
      scanned_card: null as File | null, // File upload (can be null or File)

      visit_date: new Date(),

      // Date of first visit
      first_visit:  '', // Date of first visit
      is_courier: 'OPD',
    }

    this.preconsultation = {
      appointment_id: 0,
      allergies: '',
      current_medications: '',
      personal_family_history: '',
      surgical_history: '',
      blood_pressure: '',
      pulse_rate: '',
      temperature: '',
      weight: '',
      height: '',
      fasting_blood_sugar: '',
      blood_oxygen: '',
      runny_nose: '',
      cough: '',
      chief_complaints: '',
      notes: '',
      is_courier: 'OPD',

      complaintTags: [],
    };

    this.complaintTags = [];
    this.doctorNotesDialogVisible = false;
    this.doctorNotesTab = 'notes';
    this.doctorNotesHistory = [];
    this.latestDoctorNote = '';
    this.latestDoctorNoteDate = '';
    this.specialInstructionsHistory = [];
    this.latestSpecialInstruction = '';
    this.latestSpecialInstructionDate = '';

    
  }

  private sanitizeNote(value: any): string {
    if (value === null || value === undefined) return '';
    const note = String(value).trim();
    if (!note || note.toLowerCase() === 'null' || note.toLowerCase() === 'undefined') {
      return '';
    }
    return note;
  }

  private getRecordTimestamp(record: any): number {
    const rawDate = record?.visit_date || record?.created_at || record?.updated_at;
    const time = rawDate ? new Date(rawDate).getTime() : 0;
    return Number.isFinite(time) ? time : 0;
  }

  private formatRecordDate(record: any): string {
    const rawDate = record?.visit_date || record?.created_at || record?.updated_at;
    if (!rawDate) return '';

    const date = new Date(rawDate);
    if (Number.isNaN(date.getTime())) return '';

    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

  private refreshDoctorNotes(records: any[] = []) {
    const currentPrescriptionId = Number(this.preconsultation?.id) || 0;

    const source = Array.isArray(records) ? records : [];

    const noteHistory = source
      .filter((record: any) => {
        const hasNote = !!this.sanitizeNote(record?.notes);
        const isCurrentRecord = currentPrescriptionId > 0 && Number(record?.id) === currentPrescriptionId;
        return hasNote && !isCurrentRecord;
      })
      .sort((a: any, b: any) => {
        const timeDiff = this.getRecordTimestamp(b) - this.getRecordTimestamp(a);
        if (timeDiff !== 0) return timeDiff;
        return (Number(b?.id) || 0) - (Number(a?.id) || 0);
      })
      .map((record: any) => ({
        date: this.formatRecordDate(record),
        notes: this.sanitizeNote(record?.notes)
      }));

    this.doctorNotesHistory = noteHistory;
    this.latestDoctorNote = noteHistory[0]?.notes || '';
    this.latestDoctorNoteDate = noteHistory[0]?.date || '';

    const instructionHistory = source
      .filter((record: any) => {
        const hasInstruction = !!this.sanitizeNote(record?.special_instructions);
        const isCurrentRecord = currentPrescriptionId > 0 && Number(record?.id) === currentPrescriptionId;
        return hasInstruction && !isCurrentRecord;
      })
      .sort((a: any, b: any) => {
        const timeDiff = this.getRecordTimestamp(b) - this.getRecordTimestamp(a);
        if (timeDiff !== 0) return timeDiff;
        return (Number(b?.id) || 0) - (Number(a?.id) || 0);
      })
      .map((record: any) => ({
        date: this.formatRecordDate(record),
        notes: this.sanitizeNote(record?.special_instructions)
      }));

    this.specialInstructionsHistory = instructionHistory;
    this.latestSpecialInstruction = instructionHistory[0]?.notes || '';
    this.latestSpecialInstructionDate = instructionHistory[0]?.date || '';
  }

  openDoctorNotesDialog(tab: 'notes' | 'instructions' = 'notes') {
    this.doctorNotesTab = tab;
    this.doctorNotesDialogVisible = true;
  }

  processPreConsultation() {
    if (this.preconsultation?.id) this.updatePreConsultation();
    else this.addPreConsultation();
  }

  addPreConsultation() {
    this.preConsultationService.addpreconsultation(this.preconsultation).subscribe((res: any) => {
      if (res.success) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: 'Preconsultation added successfully' });
        this.getPreConsultation();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  updatePreConsultation() {
    this.preConsultationService.updatepreconsultation(this.preconsultation).subscribe((res: any) => {
      if (res.success) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.getPreConsultation();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  deletePreConsultation(item: any) {
    this.preConsultationService.deletepreconsultation(item).subscribe(() => {
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'Preconsultation deleted successfully' });
      this.getPreConsultation();
      this.closeForm();
    });
  }

  deleteRecord(event: any) {
    if (event) this.deletePreConsultation(event);
  }

  handleEvent(event: any) {
    if (event.action.tooltip === "Update preconsultation") {
      this.editRecord = event.data;
      this.preconsultation = { ...event.data };
      setTimeout(() => { this.editRecord = null; }, 1);
    } else if (event.action.tooltip === "Delete preconsultation") {
      this.editRecord = event.data;
      this.delRecPopupOpen({ title: this.editRecord?.['name'], obj: this.editRecord });
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => { this.openDeletePopup = null; }, 1);
  }

  //! Main code for preconsulatation handling

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  normalizeComplaintTextarea(raw: any): string {
    if (!raw) return '';
    if (typeof raw === 'string') {
      const plain = raw.trim();
      if (!plain) return '';
      try {
        const parsed = JSON.parse(plain);
        return this.normalizeComplaintTextarea(parsed);
      } catch {
        return plain;
      }
    }
    if (Array.isArray(raw)) {
      return raw.map((item: any) => {
        if (item && typeof item === 'object') {
          return item.chief_complaint ?? item.complaint ?? '';
        }
        return String(item ?? '');
      }).filter(Boolean).join(', ');
    }
    return '';
  }

  private applyClinicalTextCapitalization(): void {
    capitalizeClinicalTextFields(this.preconsultation);
  }

  private applyTextReportCapitalization(): void {
    this.reportTextTitle = capitalizeLineStarts(this.reportTextTitle);
    this.reportTextContent = capitalizeLineStarts(this.reportTextContent);
  }

  normalizePatientMode(mode: any): 'OPD' | 'COURIER' | 'NRI' {
    if (mode === 'NRI') {
      return 'NRI';
    }

    if (
      mode === true ||
      mode === 'true' ||
      mode === 1 ||
      mode === '1' ||
      mode === 'Courier' ||
      mode === 'COURIER'
    ) {
      return 'COURIER';
    }

    return 'OPD';
  }

  onChiefComplaintKeydown(event: KeyboardEvent) {
    if (event.key === ' ') {
      const textarea = event.target as HTMLTextAreaElement;
      const val = textarea.value || '';
      const cursor = textarea.selectionStart;

      if (cursor > 0 && val[cursor - 1] === ' ') {
        event.preventDefault();
        
        const before = val.substring(0, cursor - 1);
        const after = val.substring(textarea.selectionEnd);
        
        this.preconsultation.chief_complaints = before + ' +' + after;
        textarea.value = this.preconsultation.chief_complaints;
        
        const newCursor = before.length + 2;
        textarea.setSelectionRange(newCursor, newCursor);
      }
    }
  }

  getModeInitial(mode: any): 'O' | 'C' | 'N' {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'C';
    if (normalized === 'NRI') return 'N';
    return 'O';
  }

  getModeTitle(mode: any): string {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'Courier';
    if (normalized === 'NRI') return 'NRI';
    return 'OPD';
  }

  getModeBadgeClass(mode: any): string {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'mode-courier';
    if (normalized === 'NRI') return 'mode-nri';
    return 'mode-opd';
  }

  isMedicineCollectionItem(item: any): boolean {
    return item?.collect_later === true || item?.collect_later === 1 || item?.collect_later === '1';
  }

  private sanitizeNamePart(value: any): string {
    if (value === null || value === undefined) return '';

    const part = String(value).trim();
    if (!part || part.toLowerCase() === 'null' || part.toLowerCase() === 'undefined') {
      return '';
    }

    return part;
  }

  buildPatientDisplayName(patient: any): string {
    const name = [
      this.sanitizeNamePart(patient?.first_name),
      this.sanitizeNamePart(patient?.middle_name),
      this.sanitizeNamePart(patient?.last_name)
    ].filter(Boolean).join(' ');

    if (name) return name;

    return this.sanitizeNamePart(patient?.full_name) || this.sanitizeNamePart(patient?.name);
  }

  getPatientSearchInitials(patient: any): string {
    const first = this.sanitizeNamePart(patient?.first_name);
    const last = this.sanitizeNamePart(patient?.last_name);
    const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
    return initials || 'P';
  }

  onPatientSearchOverlayShow() {
    this.onPatientSearchOverlayHide();
    this.unbindPatientSearchOverlayScroll = bindPatientSearchOverlayScroll();
  }

  onPatientSearchOverlayHide() {
    this.unbindPatientSearchOverlayScroll?.();
    this.unbindPatientSearchOverlayScroll = null;
  }

  getPrescriptions() {
    this.prescriptionsService.getPrescriptions().subscribe((res: any) => {
      this.prescriptionsList = res.data;
    })
  }

  refreshQueue() {
    if (this.isQueueRefreshing) return;
    this.loadQueue(true);
  }

  loadQueue(manualRefresh: boolean = false) {
    if (manualRefresh) {
      this.isQueueRefreshing = true;
    }

    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    // ✅ Check if clinic or doctor not selected
    if (!clinicId || !doctorId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Missing Selection',
        detail: 'Select the clinic and doctor',
      });
      // return; // stop execution
    }

    // const date = this.selectedDate || new Date().toISOString().slice(0, 10);
    const date = this.selectedDate || new Date(Date.now() + 19800000).toISOString().slice(0, 10);

    this.appointmentService.getQueue({
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      // date: "2025-09-12",
      slot: 60
    }).subscribe({
      next: (res: any) => {
      if (res.success) {
        const appointments = res.data.slots.flatMap((slot: any) =>
          slot.appointments.map((appt: any) => ({
            appointment_id: appt.id,
            patient_id: appt.patient_id,
            clinic_id: appt.clinic_id,
            doctor_id: appt.doctor_id,
            time: appt.start_time,
            created_at: appt.created_at,
            raw_time: appt.created_at || appt.start_time,
            status: appt.status,
            collect_later: Boolean(appt.collect_later ?? false),
            is_courier: this.normalizePatientMode(appt.is_courier),
            appointment_type: this.normalizeAppointmentType(appt.appointment_type)
          }))
        );

        // Collect all patient IDs
        const patientIds = appointments.map((a: any) => a.patient_id);

        if (!patientIds.length) {
          this.queue = [];
          this.updateNextPatientIndex();
          if (manualRefresh) {
            this.isQueueRefreshing = false;
          }
          return;
        }

        // Fetch all patient data in one request
        this.patientRegistrationService.getPatientsBatch(patientIds)
          .subscribe({
            next: (patientRes: any) => {
            if (patientRes.success) {
              const patientsMap = new Map();
              patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

              // Map appointments to patients
              this.queue = appointments.map((appt: any) => {
                const patient = patientsMap.get(appt.patient_id);
                const displayName = this.buildPatientDisplayName(patient);
                return {
                  name: displayName,
                  full_name: displayName,
                  time: this.formatTime(appt.time),
                  raw_time: appt.raw_time,
                  status: appt.status,
                  collect_later: Boolean(appt.collect_later ?? false),
                  primary_contact: patient.primary_contact,
                  secondary_contact: patient.secondary_contact,
                  is_free: patient.is_free,
                  age: patient.age,
                  appointment_id: appt.appointment_id,
                  clinic_id: appt.clinic_id,
                  doctor_id: appt.doctor_id,
                  is_courier: this.normalizePatientMode(patient?.is_courier ?? appt.is_courier),
                  appointment_type: appt.appointment_type
                };
              });

              // Sort by time once
              this.queue.sort((a, b) => a.time.localeCompare(b.time));
              this.updateNextPatientIndex();
              // console.log('Loaded queue:', this.queue);
            }
            if (manualRefresh) {
              this.isQueueRefreshing = false;
            }
          },
          error: () => {
            if (manualRefresh) {
              this.isQueueRefreshing = false;
            }
          }
        });
      }
      if (manualRefresh && !res?.success) {
        this.isQueueRefreshing = false;
      }
    },
    error: () => {
      if (manualRefresh) {
        this.isQueueRefreshing = false;
      }
    }
  });
  }

  private readonly nextQueuePriority: string[] = [
    'scheduled',
    'assistant_doctor',
  ];

  private updateNextPatientIndex() {
    this.nextPatientIndex = -1;
    if (!Array.isArray(this.queue) || this.queue.length === 0) return;

    const waitingQueue = this.queue.filter(
      (item: any) =>
        this.isQueueItemVisible(item) &&
        item?.status !== 'assistant_doctor' &&
        item?.status !== 'assistant_doctor_done'
    );
    if (waitingQueue.length === 0) return;

    for (const status of this.nextQueuePriority) {
      const candidate = waitingQueue.find((item: any) => item?.status === status);
      if (candidate) {
        this.nextPatientIndex = this.queue.findIndex(
          (item: any) => item?.appointment_id === candidate?.appointment_id
        );
        return;
      }
    }

    this.nextPatientIndex = this.queue.findIndex(
      (item: any) => item?.appointment_id === waitingQueue[0]?.appointment_id
    );
  }

  isNextPatient(index: number): boolean {
    return index === this.nextPatientIndex;
  }

  get nowServingIndex(): number {
    return this.queue.findIndex(item => item.status === 'assistant_doctor');
  }

  get nowServingPatient(): any {
    const idx = this.nowServingIndex;
    if (idx !== -1 && this.isQueueItemVisible(this.queue[idx])) {
      return { ...this.queue[idx], index: idx };
    }
    return null;
  }

  private normalizeAppointmentType(type: any): 'new' | 'follow_up' | 'case' | 'other' {
    const normalized = String(type || '').trim().toLowerCase().replace(/\s+/g, '_');
    if (normalized === 'new') return 'new';
    if (normalized === 'follow_up') return 'follow_up';
    if (normalized === 'case') return 'case';
    return 'other';
  }

  setQueueTypeFilter(type: 'all' | 'new' | 'follow_up') {
    this.queueTypeFilter = type;
    this.updateNextPatientIndex();
  }

  setQueueModeFilter(mode: 'all' | 'OPD' | 'COURIER' | 'NRI' | 'MC') {
    this.queueModeFilter = mode;
    this.updateNextPatientIndex();
  }

  get queueNewCount(): number {
    return this.queue.filter((item: any) => this.normalizeAppointmentType(item?.appointment_type) === 'new').length;
  }

  get queueFollowUpCount(): number {
    return this.queue.filter((item: any) => this.normalizeAppointmentType(item?.appointment_type) === 'follow_up').length;
  }

  get queueOpdCount(): number {
    return this.queue.filter((item: any) => this.normalizePatientMode(item?.is_courier) === 'OPD').length;
  }

  get queueCourierCount(): number {
    return this.queue.filter((item: any) => this.normalizePatientMode(item?.is_courier) === 'COURIER').length;
  }

  get queueNriCount(): number {
    return this.queue.filter((item: any) => this.normalizePatientMode(item?.is_courier) === 'NRI').length;
  }

  get queueMedicineCollectionCount(): number {
    return this.queue.filter((item: any) => this.isMedicineCollectionItem(item)).length;
  }

  isQueueItemVisible(item: any): boolean {
    const type = this.normalizeAppointmentType(item?.appointment_type);
    const mode = this.normalizePatientMode(item?.is_courier);

    const modeMatches =
      this.queueModeFilter === 'all'
        ? true
        : this.queueModeFilter === 'MC'
          ? this.isMedicineCollectionItem(item)
          : mode === this.queueModeFilter;

    if (this.queueTypeFilter === 'new') return type === 'new' && modeMatches;
    if (this.queueTypeFilter === 'follow_up') return type === 'follow_up' && modeMatches;
    return modeMatches;
  }

  getAppointmentTypeLabel(type: any): string {
    const normalized = this.normalizeAppointmentType(type);
    if (normalized === 'new') return 'New';
    if (normalized === 'follow_up') return 'Follow Up';
    if (normalized === 'case') return 'Case';
    return 'Other';
  }

  getAppointmentTypeClass(type: any): string {
    const normalized = this.normalizeAppointmentType(type);
    if (normalized === 'new') return 'apt-new';
    if (normalized === 'follow_up') return 'apt-followup';
    if (normalized === 'case') return 'apt-case';
    return 'apt-default';
  }

  selectPatient(item: any) {
    this.saveDraftSnapshot(true);

    // 1. Change appointment status
    if (item.status !== 'assistant_doctor_done') {
      this.appointmentService.changeStatus(item.appointment_id, {status:'assistant_doctor'}).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.loadQueue(); // Refresh the queue to reflect status change
          }
        },
        error: (err) => {
          console.error('Error changing status:', err);
        }
      });
    }

    // 3. Hide patient selector (queue popup)
    this.patientSelectedFromSearch = false;
    this.isPatientVisible = false;
    this.refreshDoctorNotes([]);

    // 4. Fetch full appointment details (patient + prescriptions)
    this.appointmentService.getAppointmentDetails(item.appointment_id).subscribe((res: any) => {
      if (res.success) {
        const appt = res.data;
        const patient = appt.patient;
        const prescription = appt.prescriptions?.[0] || {};
        console.log(prescription)
        // const prescription = patient.prescriptions?.[0] || {};

        // Patient form
        this.patient = {
          patient_id: patient.id,
          first_name: patient.first_name || '',
          middle_name: patient.middle_name || '',
          last_name: patient.last_name || '',
          patient_number: patient.patient_number || '',
          blood_group: patient.blood_group || '',
          gender: patient.gender || '',
          // primary_contact: patient.primary_contact || '',
          // secondary_contact: patient.secondary_contact || '',
          age: patient.age || '',
          status1: appt.status || 'Checkup',
          is_free: patient.is_free || false,
          is_courier: this.normalizePatientMode(patient.is_courier),
        };

        // Clinic/doctor ids
        this.clinicId = appt.clinic_id || 0;
        this.doctorId = appt.doctor_id || 0;

        // Active prescription form
        this.preconsultation = {
          id: prescription.id,
          appointment_id: appt.id,
          allergies: prescription.allergies || '',
          current_medications: prescription.current_medications || '',
          personal_family_history: prescription.personal_family_history || '',
          surgical_history: prescription.surgical_history || '',
          blood_pressure: prescription.blood_pressure || '',
          pulse_rate: prescription.pulse_rate || '',
          temperature: prescription.temperature || '',
          weight: prescription.weight || '',
          height: prescription.height || '',
          fasting_blood_sugar: prescription.fasting_blood_sugar || '',
          blood_oxygen: prescription.blood_oxygen || '',
          runny_nose: prescription.runny_nose || '',
          cough: prescription.cough || '',

          // chief_complaints: prescription.chief_complaints || '',
          notes: prescription.notes || '',
          is_courier: this.normalizePatientMode(prescription.is_courier ?? patient.is_courier),

          // prescriptions: prescription.prescriptions || [
          //   {
          //     id: 1,
          //     title: '',
          //     duration: '',
          //     medicines: [
          //       {
          //         tags: [
          //           {
          //             id: null,       // optional — if medicine exists in DB
          //             name: '',       // medicine name
          //             code: '',       // unique code, e.g., “A0001”
          //             potency: ''     // optional field
          //           }
          //         ],
          //         drams: '',
          //         ballers: '',
          //         medicineInput: '',         // for the input field
          //         filteredMedicines: [],     // for the suggestions dropdown
          //         medicineTags: []           // alias for tags, for backward compatibility
          //       }
          //     ]
          //   }
          // ],

          // personal_dues: prescription.personal_dues || 0,
          // visit_fees: prescription.visit_fees || 0,
          // received_cash: prescription.received_cash || 0,
          // received_online: prescription.received_online || 0,
          // notes: prescription.notes || '',
        };

        this.preconsultation.chief_complaints = this.normalizeComplaintTextarea(prescription.chief_complaints);
        this.applyClinicalTextCapitalization();

        this.restoreDraftForCurrentContext();

        // 5. Load latest history page for context; full history is lazy/paged in History tab.
        this.resetHistoryStateForPatient(patient.id);
        this.prescriptionsService.getPrescriptionsByPatientId(patient.id, {
          page: 1,
          per_page: this.historyPageSize
        }).subscribe((res: any) => {
          if (res.success && res.data) {
            const records = this.extractHistoryRecords(res);
            this.filteredRecords = records;
            this.historyCurrentPage = this.extractHistoryPage(res) || (records.length ? 1 : 0);
            this.historyTotalRecords = this.extractHistoryTotal(res, records.length);
            this.historyHasMore = this.extractHistoryHasMore(res, records.length);
            this.historyInitializedForPatientId = Number(patient.id) || 0;
            this.selectedHistoryIndex = 0;

            // ✅ Calculate personal dues
            this.preconsultation.personal_dues = this.calculatePersonalDues(
              this.filteredRecords,
              this.preconsultation
            );
            this.refreshDoctorNotes(this.filteredRecords);
            this.restoreDraftForCurrentContext();
          } else {
            this.filteredRecords = [];
            this.refreshDoctorNotes([]);
            this.restoreDraftForCurrentContext();
          }
        });

        //6. ✅ Fetch reports for this patient
        this.prescriptionsService.getReportsByPatientId(patient.id).subscribe((rRes: any) => {
          this.uploadsByDate = rRes.success ? rRes.data : [];
        });

      }
    });
  }

  searchPatients(event: any) {
    const query = event.query;
    this.http.get<any>(this.apiUrl + '/patient/search', { params: { q: query }, ...this.getAuthHeaders()})
      .subscribe(res => {
        if (!res.data || res.data.length === 0) {
          this.patientsList = [];
          this.toast.add({
            severity: 'info',
            summary: 'Info',
            detail: `No patients found for "${query}".`
          });
        } else {
          this.patientsList = res.data.map((p: any) => ({
            ...p,
            full_name: `${p.first_name} ${p.middle_name || ''} ${p.last_name} (${p.patient_number})`
          }));
        }
        // Stop spinner and update view
        this.cdr.detectChanges();
      }, error => {
        this.patientsList = [];
        this.toast.add({
          severity: 'info',
          summary: 'Info',
          detail: 'No patients found.'
        });
        this.cdr.detectChanges();
      });
  }

  onPatientSelect(event: any) {
    const outgoingPatientId = Number(this.patient?.patient_id || 0);
    if (outgoingPatientId > 0) {
      this.persistDraftSnapshot(
        {
          context_type: 'pre_consultation',
          appointment_id: this.patientSelectedFromSearch
            ? null
            : (Number(this.preconsultation?.appointment_id || 0) || null),
          patient_id: outgoingPatientId,
          patient_selected_from_search: this.patientSelectedFromSearch
        },
        true
      );
    }
    this.isDraftAutosaveSuspended = true;

    const nextPatientId = Number(event.value.id || event.value.patient_id || 0);
    this.patient.patient_id = nextPatientId;
    this.selectedPatient = '';
    this.patientSelectedFromSearch = true;
    this.searchVisitType = 'auto';
    this.isPatientVisible = false;
    this.refreshDoctorNotes([]);
    this.isDraftAutosavePausedUntilChange = false;

    this.preconsultation = {
      ...this.preconsultation,
      id: 0,
      appointment_id: 0,
      allergies: '',
      current_medications: '',
      personal_family_history: '',
      surgical_history: '',
      blood_pressure: '',
      pulse_rate: '',
      temperature: '',
      weight: '',
      height: '',
      fasting_blood_sugar: '',
      blood_oxygen: '',
      runny_nose: '',
      cough: '',
      chief_complaints: '',
      notes: '',
      personal_dues: 0,
      visit_fees: 0,
      received_cash: 0,
      received_online: 0,
    };
    this.complaintTags = [];

  // event.value is the selected patient object

    // 1. Fetch patient info
    this.patientRegistrationService.getSinglePatient(this.patient.patient_id).subscribe((res: any) => {
      if (res.success) {
        const patient = res.data;
        this.patient.full_name = `${patient.first_name} ${patient.middle_name || ''} ${patient.last_name}` || '';
        this.patient.patient_number = patient.patient_number || '';
        this.patient.first_name = patient.first_name || '';
        this.patient.middle_name = patient.middle_name || '';
        this.patient.last_name = patient.last_name || '';
        this.patient.primary_contact = patient.primary_contact || '';
        this.patient.secondary_contact = patient.secondary_contact || '';
        this.patient.age = patient.age ?? 0;
        this.patient.gender = patient.gender || '';
        this.patient.blood_group = patient.blood_group || '';
        this.patient.is_free = patient.is_free || false;
        this.patient.referred_by = patient.referred_by || '';
        this.patient.first_visit = new Date(patient.first_visit).toLocaleString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
        this.patient.address = patient.address || '';
        this.patient.city = patient.city || '';
        this.patient.state = patient.state || '';
        this.patient.country = patient.country || '';
        this.patient.pincode = patient.pincode || '';
        this.patient.is_courier = this.normalizePatientMode(patient.is_courier);
        this.preconsultation.is_courier = this.patient.is_courier;
      }
    });

    // 2. Fetch only latest page for context; full history is lazy/paged in History tab.
    this.resetHistoryStateForPatient(this.patient.patient_id);
    this.prescriptionsService.getPrescriptionsByPatientId(this.patient.patient_id, {
      page: 1,
      per_page: this.historyPageSize
    }).subscribe({
      next: (res: any) => {
      if (res.success && res.data) {
        const records = this.extractHistoryRecords(res);
        this.filteredRecords = records;
        this.historyCurrentPage = this.extractHistoryPage(res) || (records.length ? 1 : 0);
        this.historyTotalRecords = this.extractHistoryTotal(res, records.length);
        this.historyHasMore = this.extractHistoryHasMore(res, records.length);
        this.historyInitializedForPatientId = Number(this.patient.patient_id) || 0;
        this.selectedHistoryIndex = 0;

        this.preconsultation.personal_dues = this.calculatePersonalDues(
          this.filteredRecords,
          this.preconsultation
        );
        this.refreshDoctorNotes(this.filteredRecords);
        this.restoreDraftForCurrentContext(true, true);
      } else {
        this.filteredRecords = [];
        this.refreshDoctorNotes([]);
        this.restoreDraftForCurrentContext(true, true);
      }
      },
      error: () => {
        this.isDraftAutosaveSuspended = false;
      }
    });

    // ✅ Fetch reports
    this.prescriptionsService.getReportsByPatientId(this.patient.patient_id).subscribe((rRes: any) => {
      this.uploadsByDate = rRes.success ? rRes.data : [];
      // console.log('Reports:', this.uploadsByDate);
    });
  }

  getColorClass(status: string): string {
    switch (status) {
      case 'scheduled': 
        return 'bg-light-blue';
      case 'assistant_doctor': 
        return 'bg-light-purple';
      case 'assistant_doctor_done': 
        return 'bg-light-purple';
      case 'doctor': 
        return 'bg-light-coral';
      case 'medicine': 
        return 'bg-light-teal';
      case 'completed': 
        return 'bg-light-green';
      case 'cancelled': 
        return 'bg-light-red';
      default: 
        return 'bg-light-gray'; // fallback for unknown statuses
    }
  }

  /**
   * Format various time representations to HH:MM (24-hour) string.
   * Accepts strings like "HH:MM", "HH:MM:SS", ISO datetimes, or numeric timestamps.
   */
  formatTime(time: any): string {
    if (!time && time !== 0) return '';

    try {
      // If already HH:MM or HH:MM:SS
      if (typeof time === 'string' && /^\d{1,2}:\d{2}(:\d{2})?$/.test(time)) {
        return time.slice(0,5).padStart(4, '0');
      }

      // If numeric timestamp
      if (typeof time === 'number') {
        const d = new Date(time);
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
      }

      // Try parsing ISO or full datetime string
      const parsed = new Date(time);
      if (!isNaN(parsed.getTime())) {
        const hh = String(parsed.getHours()).padStart(2, '0');
        const mm = String(parsed.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
      }

      // Fallback to original
      return String(time).slice(0,5);
    } catch {
      return String(time);
    }
  }

  // addPrescriptions() {
  //   if (this.patientSelectedFromSearch) {
  //     this.saveAppointmentAndPrescription();
  //     this.patientSelectedFromSearch = false; // reset flag
  //   } else {
  //     this.savePrescriptionOnly();
  //   }
  // }

  saveDraft() {
    if (this.shouldCreateAppointmentBeforeSave()) {
      this.saveAppointmentAndPrescription('assistant_doctor_done');
      this.patientSelectedFromSearch = false;
    } else {
      this.savePrescriptionOnly('assistant_doctor_done');
    }
  }

  sendToDoctor() {
    if (this.shouldCreateAppointmentBeforeSave()) {
      this.saveAppointmentAndPrescription('doctor');
      this.patientSelectedFromSearch = false;
    } else {
      this.savePrescriptionOnly('doctor');
    }
  }

  private shouldCreateAppointmentBeforeSave(): boolean {
    if (this.patientSelectedFromSearch) return true;

    // Search-selected patient can lose the transient flag; treat missing appointment as create-flow.
    const appointmentId = Number(this.preconsultation?.appointment_id || 0);
    const patientId = Number(this.patient?.patient_id || 0);
    return patientId > 0 && appointmentId <= 0;
  }

  saveAppointmentAndPrescription(status: string) {
    const existingAppointmentId = Number(this.preconsultation?.appointment_id || 0);
    if (existingAppointmentId > 0) {
      this.savePrescriptionOnly(status);
      return;
    }

    const now = new Date();
    const appointmentDate = now.toISOString().slice(0, 10);
    const hour = now.getHours().toString().padStart(2, '0');
    const startTime = `${hour}:00`;
    const endTime = `${(now.getHours() + 1).toString().padStart(2, '0')}:00`;

    const clinicId = sessionStorage.getItem('clinic_id');
    const doctorId = sessionStorage.getItem('doctor_id');

    // Appointment payload
    const appointmentPayload = {
      clinic_id: Number(clinicId) || 1,
      doctor_id: Number(doctorId) || 1,
      // clinic_id: this.clinicId,
      // doctor_id: this.doctorId,
      patient_id: this.patient.patient_id,
      appointment_date: appointmentDate,
      appointment_type: this.resolveSearchAppointmentType(),
      start_time: startTime,
      end_time: endTime,
      status: status,
      type: 'on_flow',
    };

    this.appointmentService.addAppointment(appointmentPayload).subscribe({
      next: (res: any) => {
        if (res.success) {
          const appt = res.data;
          this.preconsultation.appointment_id = appt.id;
          const prescription = this.preconsultation;

          // Create or update prescription linked to this appointment
          const prescriptionPayload = {
            id: prescription.id,
            appointment_id: appt.id,
            allergies: prescription.allergies || '',
            current_medications: prescription.current_medications || '',
            personal_family_history: prescription.personal_family_history || '',
            surgical_history: prescription.surgical_history || '',
            blood_pressure: prescription.blood_pressure || '',
            pulse_rate: prescription.pulse_rate || '',
            temperature: prescription.temperature || '',
            weight: prescription.weight || '',
            height: prescription.height || '',
            fasting_blood_sugar: prescription.fasting_blood_sugar || '',
            blood_oxygen: prescription.blood_oxygen || '',
            runny_nose: prescription.runny_nose || '',
            cough: prescription.cough || '',
            notes: prescription.notes || '',

            personal_dues: prescription.personal_dues || 0,
            visit_fees: prescription.visit_fees || 0,
            received_cash: prescription.received_cash || 0,
            received_online: prescription.received_online || 0,

            chief_complaints: prescription.chief_complaints || '',
          };

          const prescriptionId = Number(prescription.id || 0);
          const saveObs = prescriptionId > 0
            ? this.prescriptionsService.updatePrescriptions({
                ...prescriptionPayload,
                main_action: 'save_payment',
                collect_payment: false,
              })
            : this.prescriptionsService.addPrescriptions(prescriptionPayload);

          saveObs.subscribe((res: any) => {
            if (res.success) {
              const prescription = res.data;

              // ✅ Update the current preconsultation id after save
              this.preconsultation.id = prescription.id;

              // ✅ Upload reports if there are any files waiting
              if (this.pendingFiles && this.pendingFiles.length > 0) {
                const formData = new FormData();
                formData.append('patient_id', this.patient.patient_id.toString());
                formData.append('prescription_id', prescription.id.toString());
                this.pendingFiles.forEach((file: File) => {
                  formData.append('files[]', file, file.name);
                });

                this.prescriptionsService.uploadReports(formData).subscribe({
                  next: (uploadRes: any) => {
                    if (uploadRes.success) {
                      this.pendingFiles = [];
                    }
                  },
                  error: (err) => console.error('Report upload failed:', err)
                });
              }

              const message = status === 'assistant_doctor_done' 
              ? 'Draft saved successfully' 
              : 'Pre-consultation saved successfully';

              this.toast.add({
                severity: 'success',
                summary: 'Success',
                detail: message,
              });

              this.clearDraftForCurrentContext();
              this.clearForm();
            }
          });

          this.loadQueue();

          // this.clearForm();
        }
      },
      error: (err) => {
        console.error('Save error:', err);
        const apiMessage =
          err?.error?.message ||
          err?.error?.errors?.appointment_type?.[0] ||
          'Failed to save appointment and prescription';
        this.toast.add({
          severity: 'error',
          summary: 'Error',
          detail: apiMessage,
        });
      }
    });
  }

  private resolveSearchAppointmentType(): 'new' | 'follow up' {
    if (this.searchVisitType === 'new') {
      return 'new';
    }

    if (this.searchVisitType === 'follow_up') {
      return 'follow up';
    }

    const hasHistory = Array.isArray(this.filteredRecords) && this.filteredRecords.length > 0;
    return hasHistory ? 'follow up' : 'new';
  }

  savePrescriptionOnly(status: string) {
      if (this.shouldCreateAppointmentBeforeSave()) {
      this.saveAppointmentAndPrescription(status);
      this.patientSelectedFromSearch = false;
      return;
    }

      if (!this.patient.patient_id) {
      console.error('No patient selected!');
      this.toast.add({ severity: 'error', summary: 'Error', detail: 'Please select a patient first.' });
      return;
    }

    const appointmentId = Number(this.preconsultation?.appointment_id || 0);
    if (appointmentId <= 0) {
      this.toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No appointment linked to this pre-consultation. Please select the patient from the queue again.',
      });
      return;
    }

    this.applyClinicalTextCapitalization();

    const preconsultationPayload = {
      ...this.preconsultation,
      appointment_id: appointmentId,
      chief_complaints: this.preconsultation.chief_complaints || '',
    };

    const prescriptionId = Number(this.preconsultation?.id || 0);
    const saveObs = prescriptionId > 0
      ? this.prescriptionsService.updatePrescriptions({
          ...preconsultationPayload,
          id: prescriptionId,
          main_action: 'save_payment',
          collect_payment: false,
        })
      : this.prescriptionsService.addPrescriptions(preconsultationPayload);

    saveObs.subscribe({
      next: (res: any) => {
        if (!res.success) {
          this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
          return;
        }

        const preconsultation = res.data;

        // ✅ Update the current preconsultation id after save
        this.preconsultation.id = preconsultation.id;

        // Upload reports if any
        if (this.pendingFiles && this.pendingFiles.length > 0) {
          const formData = new FormData();
          formData.append('patient_id', this.patient.patient_id.toString());
          formData.append('prescription_id', this.preconsultation.id.toString());

          this.pendingFiles.forEach((file: File) => {
            formData.append('files[]', file, file.name);
          });

          this.prescriptionsService.uploadReports(formData).subscribe({
            next: (uploadRes: any) => {
              if (uploadRes.success) {
                this.pendingFiles = []; // ✅ Clear pending files after successful upload
              } else {
                console.error('Report upload failed:', uploadRes.message);
              }
            },
            error: (err) => console.error('Report upload failed:', err)
          });
        }

        const message = status === 'assistant_doctor_done'
        ? 'Draft saved successfully'
        : res.message;

        this.toast.add({ severity: 'success', summary: 'Success', detail: message });

        // Refresh prescriptions and queue
        this.getPrescriptions();
        if (this.preconsultation.appointment_id) {
          this.appointmentService.changeStatus(this.preconsultation.appointment_id, {status:status}).subscribe({
            next: () => this.loadQueue(),
            error: (err) => console.error('Error changing status:', err)
          });
        }

        // ✅ Clear forms only after everything is handled
        this.clearDraftForCurrentContext();
        this.clearForm();
        this.closeForm();
      },
      error: (err) => {
        console.error('Error saving prescription:', err);
        this.toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to save prescription.' });
      }
    });
  }

  addPrescriptions() {
    this.sendToDoctor();
  }

  private hasAnyDraftContent(): boolean {
    const data = this.preconsultation || {};

    return !!(
      String(data.allergies || '').trim() ||
      String(data.current_medications || '').trim() ||
      String(data.personal_family_history || '').trim() ||
      String(data.surgical_history || '').trim() ||
      String(data.blood_pressure || '').trim() ||
      String(data.pulse_rate || '').trim() ||
      String(data.temperature || '').trim() ||
      String(data.weight || '').trim() ||
      String(data.height || '').trim() ||
      String(data.fasting_blood_sugar || '').trim() ||
      String(data.blood_oxygen || '').trim() ||
      String(data.notes || '').trim() ||
      String(data.chief_complaints || '').trim() ||
      Number(data.visit_fees || 0) > 0 ||
      Number(data.received_cash || 0) > 0 ||
      Number(data.received_online || 0) > 0 ||
      data.runny_nose ||
      data.cough ||
      (Array.isArray(this.pendingFiles) && this.pendingFiles.length > 0)
    );
  }

  private getDraftQuery() {
    const patientId = Number(this.patient?.patient_id || 0);
    const appointmentId = this.patientSelectedFromSearch
      ? 0
      : Number(this.preconsultation?.appointment_id || 0);

    if (appointmentId <= 0 && patientId <= 0) {
      return null;
    }

    return {
      context_type: 'pre_consultation' as const,
      appointment_id: appointmentId > 0 ? appointmentId : null,
      patient_id: patientId > 0 ? patientId : null,
      patient_selected_from_search: this.patientSelectedFromSearch
    };
  }

  private getDraftClearQuery() {
    const patientId = Number(this.patient?.patient_id || 0);
    const appointmentId = this.patientSelectedFromSearch
      ? 0
      : Number(this.preconsultation?.appointment_id || 0);

    if (appointmentId <= 0 && patientId <= 0) {
      return null;
    }

    return {
      context_type: 'pre_consultation' as const,
      appointment_id: appointmentId > 0 ? appointmentId : null,
      patient_id: patientId > 0 ? patientId : null
    };
  }

  private buildDraftPayload() {
    const draftPreconsultation = {
      ...this.preconsultation,
      appointment_id: this.patientSelectedFromSearch
        ? 0
        : Number(this.preconsultation?.appointment_id || 0)
    };

    return {
      saved_at: new Date().toISOString(),
      preconsultation: draftPreconsultation,
      searchVisitType: this.searchVisitType
    };
  }

  private persistDraftSnapshot(
    query: {
      context_type: 'pre_consultation';
      appointment_id?: number | null;
      patient_id?: number | null;
      patient_selected_from_search?: boolean;
    },
    force = false
  ) {
    if (!force && this.isDraftAutosavePausedUntilChange) return;
    if (!query.patient_id && !query.appointment_id) return;
    if (!force && !this.hasAnyDraftContent()) return;

    this.draftSaveState = 'saving';
    this.draftSaveLabel = 'Saving draft...';

    this.consultationDraftService.saveDraft(query, this.buildDraftPayload()).subscribe({
      next: () => {
        const savedAt = new Date().toLocaleTimeString('en-IN', {
          hour: '2-digit',
          minute: '2-digit'
        });
        this.draftSaveState = 'saved';
        this.draftSaveLabel = `Draft saved at ${savedAt}`;
        this.canClearDraftFlag = true;
      },
      error: () => {
        this.draftSaveState = 'error';
        this.draftSaveLabel = 'Draft save failed';
        this.refreshDraftAvailability();
      }
    });
  }

  private saveDraftSnapshot(force = false) {
    const query = this.getDraftQuery();
    if (!query) {
      this.canClearDraftFlag = false;
      return;
    }
    this.persistDraftSnapshot(query, force);
  }

  private draftMatchesCurrentContext(data: any): boolean {
    if (!data) return false;

    const currentPatientId = Number(this.patient?.patient_id || 0);
    const currentAppointmentId = this.patientSelectedFromSearch
      ? 0
      : Number(this.preconsultation?.appointment_id || 0);
    const scopeType = String(data.scope_type || '');
    const scopeId = Number(data.scope_id || 0);

    if (this.patientSelectedFromSearch) {
      return scopeType === 'patient' && scopeId === currentPatientId;
    }

    if (currentAppointmentId > 0) {
      return scopeType === 'appointment' && scopeId === currentAppointmentId;
    }

    return scopeType === 'patient' && scopeId === currentPatientId;
  }

  private restoreDraftForCurrentContext(showToast = false, resumeAutosaveAfter = false) {
    const query = this.getDraftQuery();
    if (!query) {
      this.canClearDraftFlag = false;
      if (resumeAutosaveAfter) {
        this.isDraftAutosaveSuspended = false;
      }
      return;
    }

    this.consultationDraftService.getDraft(query).subscribe({
      next: (res: any) => {
        if (!this.draftMatchesCurrentContext(res?.data)) {
          this.refreshDraftAvailability();
          return;
        }

        const parsed = res?.data?.payload;
        if (!parsed?.preconsultation) {
          this.refreshDraftAvailability();
          return;
        }
        if (!this.isSavedToday(parsed?.saved_at)) {
          this.refreshDraftAvailability();
          return;
        }

        this.preconsultation = {
          ...this.preconsultation,
          ...parsed.preconsultation
        };
        this.applyClinicalTextCapitalization();

        if (parsed.searchVisitType === 'auto' || parsed.searchVisitType === 'new' || parsed.searchVisitType === 'follow_up') {
          this.searchVisitType = parsed.searchVisitType;
        }

        if (showToast) {
          this.toast.add({
            severity: 'info',
            summary: 'Draft Restored',
            detail: 'Recovered unsaved pre-consultation changes for this patient.'
          });
        }

        this.draftSaveState = 'saved';
        this.draftSaveLabel = 'Draft restored';
        this.canClearDraftFlag = true;
      },
      error: () => {
        this.refreshDraftAvailability();
      },
      complete: () => {
        if (resumeAutosaveAfter) {
          this.isDraftAutosaveSuspended = false;
        }
      }
    });
  }

  private isSavedToday(savedAt: any): boolean {
    if (!savedAt) return false;
    const savedDate = new Date(savedAt);
    if (Number.isNaN(savedDate.getTime())) return false;

    const now = new Date();
    return savedDate.getFullYear() === now.getFullYear() &&
      savedDate.getMonth() === now.getMonth() &&
      savedDate.getDate() === now.getDate();
  }

  private clearDraftForCurrentContext() {
    const query = this.getDraftClearQuery();
    if (!query) return;

    this.consultationDraftService.clearDraft(query).subscribe({
      next: () => {
        this.isDraftAutosavePausedUntilChange = true;
        this.draftSaveState = 'cleared';
        this.draftSaveLabel = 'Draft cleared';
        this.canClearDraftFlag = false;
      },
      error: () => {
        this.refreshDraftAvailability();
      }
    });
  }

  canClearDraft(): boolean {
    return this.canClearDraftFlag;
  }

  clearCurrentDraft(event: Event) {
    const query = this.getDraftQuery();
    if (!query) {
      this.toast.add({
        severity: 'info',
        summary: 'No Draft',
        detail: 'No draft found for current patient.'
      });
      return;
    }

    this.consultationDraftService.getDraft(query).subscribe({
      next: (res: any) => {
        if (!res?.data?.payload) {
          this.canClearDraftFlag = false;
          this.toast.add({
            severity: 'info',
            summary: 'No Draft',
            detail: 'No draft found for current patient.'
          });
          return;
        }

        this.confirmationService.confirm({
          key: 'clearDraftConfirm',
          target: (event?.currentTarget || event?.target) as EventTarget,
          message: 'Clear saved draft for this patient?',
          icon: 'pi pi-inbox',
          acceptLabel: 'Clear draft',
          rejectLabel: 'Keep draft',
          acceptButtonStyleClass: 'pc-draft-clear-accept',
          rejectButtonStyleClass: 'pc-draft-clear-reject',
          accept: () => {
            this.clearDraftForCurrentContext();
            this.toast.add({
              severity: 'success',
              summary: 'Draft Cleared',
              detail: 'Saved draft removed for current patient.'
            });
          }
        });
      },
      error: () => {
        this.toast.add({
          severity: 'info',
          summary: 'No Draft',
          detail: 'No draft found for current patient.'
        });
      }
    });
  }

  get draftStatusIcon(): string {
    if (this.draftSaveState === 'saving') return 'pi pi-spin pi-spinner';
    if (this.draftSaveState === 'saved') return 'pi pi-check-circle';
    if (this.draftSaveState === 'error') return 'pi pi-exclamation-circle';
    if (this.draftSaveState === 'cleared') return 'pi pi-trash';
    return 'pi pi-save';
  }

  private refreshDraftAvailability() {
    const query = this.getDraftQuery();
    if (!query) {
      this.canClearDraftFlag = false;
      return;
    }

    this.consultationDraftService.getDraft(query).subscribe({
      next: (res: any) => {
        this.canClearDraftFlag = !!res?.data?.payload;
      },
      error: () => {
        this.canClearDraftFlag = false;
      }
    });
  }

  private mergeReports(newReports: any[]) {
    newReports.forEach(r => {
      const date = r.uploaded_at.split(' ')[0];
      let group = this.uploadsByDate.find(g => g.date === date);
      if (!group) {
        group = { date, files: [] };
        this.uploadsByDate.push(group);
      }
      group.files.push(r);
    });
  }

  calculatePersonalDues(records: any[], current: any): number {
    let lastDue = 0;

    if (records && records.length > 0) {
      // Find the most recent prescription with dues > 0
      const last = records.find((r: any) => r.personal_dues && r.personal_dues >= 0);
      if (last) {
        lastDue = Number(last.personal_dues);
      }
    }

    const visitFees = current.visit_fees || 0;
    const receivedCash = current.received_cash || 0;
    const receivedOnline = current.received_online || 0;

    return (visitFees - (receivedCash + receivedOnline)) + lastDue;
  }

  calculateTotalPrice() {
    const qty = Number(this.quantity) || 0;
    const price = Number(this.unitPrice) || 0;
    this.totalPrice = qty * price;
  }

  // ===========================
  // AI Plan generation (optional)
  // ===========================
  async generatePlan() {
    if (!this.aiService.isAiEnabled) {
      this.toast.add({
        severity: 'warn',
        summary: 'AI Disabled',
        detail: 'AI features are currently turned off.',
      });
      return;
    }

    this.isLoading = true;

    const { first_name, middle_name, last_name } = this.preconsultation;
    this.preconsultation.full_name = [first_name, middle_name, last_name]
      .filter(name => name && name.trim() !== '')
      .join(' ');

    const patient = {
      id: this.patient?.id,
      clinic_id: this.patient?.clinic_id,
      first_name: this.preconsultation.first_name || this.patient?.first_name || '',
      middle_name: this.preconsultation.middle_name || this.patient?.middle_name || '',
      last_name: this.preconsultation.last_name || this.patient?.last_name || '',
      age: this.preconsultation.age || this.patient?.age,
      gender: this.preconsultation.gender || this.patient?.gender,
    };

    const prescriptionPayload = {
      blood_pressure: this.preconsultation.blood_pressure,
      pulse_rate: this.preconsultation.pulse_rate,
      temperature: this.preconsultation.temperature,
      weight: this.preconsultation.weight,
      height: this.preconsultation.height,
      fasting_blood_sugar: this.preconsultation.fasting_blood_sugar,
      blood_oxygen: this.preconsultation.oxygenSaturation,
      runny_nose: this.toYesNoFlag(this.preconsultation.coldRunnyNose),
      cough: this.toYesNoFlag(this.preconsultation.cough),
      chief_complaints: this.preconsultation.currentComplaints || '',
      allergies: this.preconsultation.allergies,
      current_medications: this.preconsultation.currentMedication,
      personal_family_history: this.preconsultation.history,
      surgical_history: this.preconsultation.surgicalHistory,
      suggested_reports: [],
      prescriptions: [],
    };

    try {
      const response: any = await this.aiService
        .generatePlan(patient, prescriptionPayload)
        .toPromise();

      if (response?.success) {
        this.aiPlan = response.data.html || '';
        this.preconsultation.dietPlan = this.formatPlanSection(response.data.diet);
        this.preconsultation.exercisePlan = this.formatPlanSection(response.data.exercise);
      } else {
        this.aiPlan = '';
        this.preconsultation.dietPlan = '';
        this.preconsultation.exercisePlan = '';
        this.toast.add({
          severity: 'error',
          summary: 'Error',
          detail: response?.message || 'Failed to generate AI consultation report',
        });
      }
    } catch (err) {
      console.error(err);
      this.aiPlan = '';
      this.preconsultation.dietPlan = '';
      this.preconsultation.exercisePlan = '';
      this.toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'An error occurred while generating AI consultation report',
      });
    } finally {
      this.isLoading = false;
    }
  }

  private toYesNoFlag(value: unknown): number {
    if (value === true || value === 1 || value === '1' || value === 'Yes' || value === 'yes') {
      return 1;
    }

    return 0;
  }

  private formatPlanSection(value: unknown): string {
    if (Array.isArray(value)) {
      return value.map(item => `• ${item}`).join('\n');
    }

    return String(value ?? '').trim();
  }

  // ===========================
  // Generate PDF safely (no alert)
  // ===========================
  async generatePDF() {
    // Show "generating PDF" message
    const generatingMsg = { severity: 'info', summary: 'Info', detail: 'Generating PDF...' };
    this.toast.add(generatingMsg);

    try {
      // Ensure AI plan exists
      if (!this.aiPlan) await this.generatePlan();

      const doc = new jsPDF({ unit: 'mm', format: 'a4' });
      const margin = 15;
      let yPos = 20;

      const content = this.aiPlan || `
      Patient Summary
      Name: ${this.patient.first_name || "N/A"} ${this.patient.mid_name || ""} ${this.patient.last_name || "N/A"}
      Age: ${this.patient.age || "N/A"}
      Gender: ${this.patient.gender || "N/A"}
      Blood Pressure: ${this.preconsultation.blood_pressure || "N/A"}
      Pulse: ${this.preconsultation.pulse_rate || 0}
      Temperature: ${this.preconsultation.temperature || 0}
      Weight: ${this.preconsultation.weight || 0}
      Height: ${this.preconsultation.height || 0}
      Fasting Blood Sugar: ${this.preconsultation.fasting_blood_sugar || ''}
      Blood Oxygen: ${this.preconsultation.blood_oxygen || ''}
      `;

      const lines = content.split('\n');

      doc.setFont('helvetica');
      lines.forEach((line) => {
        line = line.trim();
        if (!line) { yPos += 5; return; }

        if (/Patient Summary|Diagnosis|Understanding|Scope|Approach|Final Thoughts|Diet Plan|Exercise Plan/i.test(line)) {
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(12);
          yPos += 5;
        } else {
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(10);
        }

        if (/^\- /.test(line)) line = '• ' + line.slice(2);

        const splitText = doc.splitTextToSize(line, 180);
        doc.text(splitText, margin, yPos);
        yPos += splitText.length * 6;

        if (yPos > 280) { doc.addPage(); yPos = 20; }
      });

      const pdfBlob = doc.output('blob');
      const blobUrl = URL.createObjectURL(pdfBlob);
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);  // ✅ safe URL

      // Show success message
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'PDF generated successfully.' });

    } catch (error) {
      console.error('Error generating PDF:', error);
      this.toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF.' });
    }
  }


  // onFileUpload(event: any) {
  //   const files = event.target.files;
  //   const today = new Date();

  //   let group = this.uploadsByDate.find(
  //     g => g.date.toDateString() === today.toDateString()
  //   );

  //   if (!group) {
  //     group = { date: today, files: [] };
  //     this.uploadsByDate.unshift(group); // latest date always at top
  //   }

  //   for (let file of files) {
  //     const fileObj = {
  //       name: file.name,
  //       type: file.type,
  //       url: URL.createObjectURL(file)
  //     };
  //     group.files.push(fileObj);
  //   }
  // }

  onFileUpload(event: any) {
    this.pendingFiles = Array.from(event.target.files);
  }

  openFile(file: any) {
    if (!file) return;

    if (isTextReportFile(file)) {
      this.openTextReportViewer(file);
      return;
    }

    if (!file?.url) return;
    window.open(file.url, "_blank");
  }

  isTextReport(file: any): boolean {
    return isTextReportFile(file);
  }

  getTextReportBody(file: any = this.viewingTextReport): string {
    return getTextReportBody(file);
  }

  getTextReportExcerpt(file: any, maxLength = 140): string {
    return getTextReportExcerpt(file, maxLength);
  }

  getTextReportLineCount(file: any): number {
    return getTextReportLineCount(file);
  }

  getTextReportDraftCount(): number {
    return getTextReportCharCount(this.reportTextContent);
  }

  isTextReportContentOverLimit(): boolean {
    return isTextReportOverLimit(this.reportTextContent, this.textReportMaxLength);
  }

  getTextReportCounterLabel(): string {
    return formatTextReportCounter(this.getTextReportDraftCount(), this.textReportMaxLength);
  }

  openTextReportViewer(file: any): void {
    if (!isTextReportFile(file)) {
      return;
    }

    const localText = getTextReportBody(file);
    if (localText) {
      this.viewingTextReport = file;
      this.textReportViewerLoading = false;
      this.textReportViewerVisible = true;
      return;
    }

    const reportId = Number(file?.id ?? 0);
    if (!reportId) {
      return;
    }

    this.viewingTextReport = file;
    this.textReportViewerLoading = true;
    this.textReportViewerVisible = true;

    this.prescriptionsService.getReportById(reportId).subscribe({
      next: (res: any) => {
        this.textReportViewerLoading = false;
        if (!res?.success || !res?.data) {
          this.toast.add({
            severity: 'error',
            summary: 'Load Failed',
            detail: res?.message || 'Unable to load text report.',
          });
          return;
        }

        this.viewingTextReport = res.data;
        this.upsertReportFileInGallery(res.data);
      },
      error: (err) => {
        this.textReportViewerLoading = false;
        this.toast.add({
          severity: 'error',
          summary: 'Load Failed',
          detail: err?.error?.message || 'Unable to load text report.',
        });
      },
    });
  }

  closeTextReportViewer(): void {
    this.textReportViewerVisible = false;
    this.textReportViewerLoading = false;
    this.viewingTextReport = null;
  }

  private upsertReportFileInGallery(updated: any): void {
    const reportId = Number(updated?.id ?? 0);
    if (!reportId) {
      return;
    }

    for (const group of this.uploadsByDate || []) {
      for (let index = 0; index < (group.files || []).length; index++) {
        if (Number(group.files[index]?.id) === reportId) {
          group.files[index] = { ...group.files[index], ...updated };
          return;
        }
      }
    }
  }

  copyTextReportContent(): void {
    const content = getTextReportBody(this.viewingTextReport);
    if (!content) {
      return;
    }

    navigator.clipboard?.writeText(content).then(() => {
      this.toast.add({
        severity: 'success',
        summary: 'Copied',
        detail: 'Report text copied to clipboard.',
      });
    }).catch(() => {
      this.toast.add({
        severity: 'warn',
        summary: 'Copy failed',
        detail: 'Unable to copy report text.',
      });
    });
  }

  deleteUploadedReport(file: any, event?: Event) {
    event?.stopPropagation();
    event?.preventDefault();
    const target = (event?.currentTarget || event?.target) as HTMLElement | undefined;
    const reportId = Number(file?.id ?? file?.report_id);
    const isSavedReport = Number.isFinite(reportId) && reportId > 0;

    this.confirmationService.confirm({
      key: 'reportDeleteConfirm',
      target,
      message: isSavedReport
        ? 'Delete this report permanently?'
        : 'Remove this unsaved report from the current screen?',
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'report-confirm-accept',
      rejectButtonStyleClass: 'report-confirm-reject',
      accept: () => {
        if (!isSavedReport) {
          this.removeLocalReportFromGallery(file);
          this.toast.add({
            severity: 'success',
            summary: 'Removed',
            detail: 'Unsaved report removed from the current screen.'
          });
          return;
        }

        this.prescriptionsService.deleteReport(reportId).subscribe({
          next: (res: any) => {
            if (res?.success) {
              this.removeReportFromGallery(reportId);
              this.toast.add({
                severity: 'success',
                summary: 'Deleted',
                detail: 'Report deleted successfully.'
              });
              return;
            }

            this.toast.add({
              severity: 'error',
              summary: 'Delete Failed',
              detail: res?.message || 'Unable to delete report.'
            });
          },
          error: (err) => {
            this.toast.add({
              severity: 'error',
              summary: 'Delete Failed',
              detail: err?.error?.message || 'Unable to delete report.'
            });
          }
        });
      }
    });
  }

  private removeLocalReportFromGallery(fileToRemove: any) {
    this.uploadsByDate = (this.uploadsByDate || [])
      .map((group: any) => ({
        ...group,
        files: (group?.files || []).filter((f: any) => f !== fileToRemove)
      }))
      .filter((group: any) => (group?.files || []).length > 0);
  }

  private removeReportFromGallery(reportId: number) {
    this.uploadsByDate = (this.uploadsByDate || [])
      .map((group: any) => ({
        ...group,
        files: (group?.files || []).filter((f: any) => Number(f?.id) !== reportId)
      }))
      .filter((group: any) => (group?.files || []).length > 0);
  }

  filterRecords() {
    if (!this.fromDate && !this.toDate) {
      this.filteredRecords = [...this.allRecords];
      return;
    }

    const from = this.fromDate ? new Date(this.fromDate) : null;
    const to = this.toDate ? new Date(this.toDate) : null;

    this.filteredRecords = this.allRecords.filter(record => {
      const recordDate = new Date(record.date);

      // Apply range filters
      if (from && recordDate < from) return false;
      if (to && recordDate > to) return false;

      return true;
    });
  }

  scrollToRecord(index: number) {
    const el = document.getElementById('record-' + index);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollToToday() {
    // Assuming latest record is at index 0 after reverse
    const el = document.getElementById('record-0');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  trackByHistoryIndex(index: number): number {
    return index;
  }


  sampleRecords = [
    {
      visit_date: new Date('2025-09-16'),
      chief_complaints: ['Headache', 'Fever'],
      investigations: ['Blood Test', 'X-Ray'],
      prescriptions: [
        {
          medicines: [
            { name: 'Paracetamol', dosage: '500mg', duration: '5 days' },
            { name: 'Ibuprofen', dosage: '200mg', duration: '7 days' }
          ]
        }
      ]
    },
    {
      visit_date: new Date('2025-09-17'),
      chief_complaints: ['Cough', 'Cold'],
      investigations: ['CBC Test'],
      prescriptions: [
        {
          medicines: [
            { name: 'Cough Syrup', dosage: '10ml', duration: '3 days' },
            { name: 'Cetirizine', dosage: '5mg', duration: '5 days' }
          ]
        }
      ]
    },
    {
      visit_date: new Date('2025-09-18'),
      chief_complaints: ['Stomach Pain'],
      investigations: ['Ultrasound'],
      prescriptions: [
        {
          medicines: [
            { name: 'Antacid', dosage: '1 tablet', duration: '7 days' },
            { name: 'Omeprazole', dosage: '20mg', duration: '10 days' }
          ]
        }
      ]
    }
  ];


  openPatientCard() {
    this.activeIndex = 0; // switch to "Patient Card" tab
  }

  onFileSelect(event: any) {
    console.log('Selected files:', event.target.files);
    // const files = event.target.files as FileList;
    const files = Array.from(event.target.files as FileList);
    if (!files || files.length === 0) {
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    const maxFileSize = PrescriptionsService.REPORT_UPLOAD_MAX_BYTES;

    const validFiles: File[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // --- Validation Step 1: File Type ---
      if (!allowedTypes.includes(file.type)) {
        this.toast.add({
          severity: 'error',
          summary: 'Invalid File Type',
          detail: `File '${file.name}' was rejected. Only PDF, JPG, and PNG are allowed.`
        });
        continue; // Skip this file
      }

      // --- Validation Step 2: File Size ---
      if (file.size > maxFileSize) {
        const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
        this.toast.add({
          severity: 'error',
          summary: 'File Too Large',
          detail: `File '${file.name}' (${fileSizeMB} MB) exceeds the ${PrescriptionsService.REPORT_UPLOAD_MAX_MB} MB limit.`
        });
        continue; // Skip this file
      }

      // If all checks pass, add the file to our valid list
      validFiles.push(file);
    }

    // Now, assign only the validated files to your main property
    this.pendingFiles = validFiles;
    console.log('Valid files ready for upload:', this.pendingFiles);

    // Optional: Give a summary message if some files were selected
    if (this.pendingFiles.length > 0) {
      this.toast.add({
        severity: 'info',
        summary: 'Files Ready',
        detail: `${this.pendingFiles.length} file(s) are ready to be uploaded.`
      });
    }

    // Reset the file input to allow re-selection of the same file
    event.target.value = '';
  }

  onUploadSelectedFiles() {
    if (!this.pendingFiles || this.pendingFiles.length === 0) {
      this.toast.add({
        severity: 'warn',
        summary: 'No Files',
        detail: 'Please select valid files before uploading.'
      });
      return;
    }

    const today = new Date();

    // 🔹 Find existing group for today, or create a new one
    let group = this.uploadsByDate.find(
      g => new Date(g.date).toDateString() === today.toDateString()
    );

    if (!group) {
      group = { date: today, files: [] };
      this.uploadsByDate.unshift(group);
    }

    const filesToProcessCount = this.pendingFiles.length;
    let processedCount = 0;

    // 🔹 Process each file asynchronously
    this.pendingFiles.forEach(file => {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        // ✅ Push processed file into today's group
        group!.files.push({
          name: file.name,
          type: file.type,
          url: e.target.result, // base64 preview
        });

        processedCount++;

        // ✅ When all files processed, show message and clear queue
        if (processedCount === filesToProcessCount) {
          this.toast.add({
            severity: 'success',
            summary: 'Upload Complete',
            detail: `${filesToProcessCount} file(s) have been successfully added.`
          });

          // 🔹 Only clear after all async FileReaders are done
          // this.pendingFiles = [];

          // Optional: trigger change detection if UI doesn’t auto-update
          // this.cd.detectChanges();
        }
      };

      reader.onerror = () => {
        processedCount++;
        console.error(`Error reading file: ${file.name}`);
        if (processedCount === filesToProcessCount) {
          // this.pendingFiles = [];
        }
      };

      // 🔹 Start reading the file
      reader.readAsDataURL(file);
    });
  }

  saveTextReport() {
    this.applyTextReportCapitalization();

    const patientId = Number(this.patient?.patient_id ?? this.patient?.id ?? 0);
    const prescriptionId = Number(this.preconsultation?.id ?? 0);
    const text = String(this.reportTextContent || '').trim();
    const title = String(this.reportTextTitle || '').trim();

    if (!patientId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Patient Missing',
        detail: 'Select a patient before saving a text report.'
      });
      return;
    }

    if (!text) {
      this.toast.add({
        severity: 'warn',
        summary: 'No Text',
        detail: 'Enter report text before saving.'
      });
      return;
    }

    if (isTextReportOverLimit(text, this.textReportMaxLength)) {
      this.toast.add({
        severity: 'error',
        summary: 'Text Too Long',
        detail: `Text reports are limited to ${this.textReportMaxLength.toLocaleString()} characters.`,
      });
      return;
    }

    this.isSavingTextReport = true;
    this.prescriptionsService.uploadTextReport({
      patient_id: patientId,
      prescription_id: prescriptionId > 0 ? prescriptionId : undefined,
      report_title: title || undefined,
      report_text: text
    }).subscribe({
      next: (res: any) => {
        this.isSavingTextReport = false;
        if (res?.success) {
          this.mergeReports(Array.isArray(res?.data) ? res.data : []);
          this.reportTextTitle = '';
          this.reportTextContent = '';
          this.toast.add({
            severity: 'success',
            summary: 'Saved',
            detail: 'Text report saved successfully.'
          });
          return;
        }

        this.toast.add({
          severity: 'error',
          summary: 'Save Failed',
          detail: res?.message || 'Unable to save text report.'
        });
      },
      error: (err) => {
        this.isSavingTextReport = false;
        this.toast.add({
          severity: 'error',
          summary: 'Save Failed',
          detail: err?.error?.message || 'Unable to save text report.'
        });
      }
    });
  }

  //! Chief Complaints Tagging Logic

  getChiefComplaints() {
    this.chiefComplaintService.getChiefComplaint().subscribe((res: any) => {
      // Convert all to lowercase for consistent search
      this.allComplaints = res.data;
      // console.log(this.allComplaints);
    });
  }

  formatTagDisplay(tag: string | any): string {
    // if it's an object, get the text property
    const text = typeof tag === 'string' ? tag : tag.chief_complaint || tag.report || '';
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
  }

  removeComplaintTag(tag: string) {
    this.complaintTags = this.complaintTags.filter(t => t !== tag);
  }

  onComplaintInputChange() {
    const value = this.preconsultation.chief_complaints.trim().toLowerCase();
    if (value.length < 1) {
      this.filteredComplaints = [];
      return;
    }

    this.filteredComplaints = this.allComplaints
      .filter((c: any) => {
        // const text = typeof c === 'string' ? c : c.chief_complaint;
        // return (
        //   text.toLowerCase().includes(value) &&
        //   !this.complaintTags.includes(text.toLowerCase())
        // );

        const text = (typeof c === 'string' ? c : c.chief_complaint)?.toLowerCase();
        return text.startsWith(value) && !this.complaintTags.includes(text);
      })
      .slice(0, 5);

    // console.log(this.filteredComplaints);
  }

  onComplaintEnter(event: any) {
    event.preventDefault();
    const value = this.preconsultation.chief_complaints.trim().toLowerCase();
    if (!value) return;

    // Check if already selected (support both string/object)
    const exists = this.complaintTags.some(
      (c: any) => (typeof c === 'string' ? c : c.chief_complaint) === value
    );
    if (exists) {
      this.preconsultation.chief_complaints = '';
      return;
    }

    // Check if it exists in allComplaints
    const known = this.allComplaints.some(
      (c: any) => (typeof c === 'string' ? c : c.chief_complaint) === value
    );

    if (!known) {
      // Call API to add new chief complaint
      this.chiefComplaintService
        .addChiefComplaint({ chief_complaint: value })
        .subscribe({
          next: (res: any) => {
            const newComplaint = {
              id: res.data.id,
              chief_complaint: res.data.chief_complaint,
            };

            this.allComplaints.push(newComplaint.chief_complaint);
            this.addComplaintTag(newComplaint);
            this.getChiefComplaints();
          },
          error: err => console.error('Error adding complaint', err),
        });
    } else {
      this.addComplaintTag({ id: null, chief_complaint: value });
      this.getChiefComplaints();
    }
  }

  get selectedHistoryRecord(): any | null {
    if (!Array.isArray(this.filteredRecords) || this.filteredRecords.length === 0) return null;
    const boundedIndex = Math.max(0, Math.min(this.selectedHistoryIndex, this.filteredRecords.length - 1));
    return this.filteredRecords[boundedIndex] || null;
  }

  trackByHistoryRecord(index: number, record: any): number {
    return Number(record?.id) || index;
  }

  getPotencyParts(potency: any): { hasHighlight: boolean; prefix: string; suffix: string } {
    const raw = String(potency ?? '').trim();
    if (!raw) return { hasHighlight: false, prefix: '', suffix: '' };

    const upper = raw.toUpperCase();
    const markers = ['MT', 'BC', 'LM', 'Q'];
    const marker = markers.find((m) => upper.startsWith(m));

    if (!marker) {
      return { hasHighlight: false, prefix: raw, suffix: '' };
    }

    return {
      hasHighlight: true,
      prefix: marker,
      suffix: raw.slice(marker.length)
    };
  }

  getCodeParts(code: any): { hasHighlight: boolean; prefix: string; suffix: string } {
    const raw = String(code ?? '').trim();
    if (!raw) return { hasHighlight: false, prefix: '', suffix: '' };

    const upper = raw.toUpperCase();
    const markers = ['MT', 'BC', 'LM', 'Q'];
    const marker = markers.find((m) => upper.startsWith(m));

    if (!marker) {
      return { hasHighlight: false, prefix: raw, suffix: '' };
    }

    return {
      hasHighlight: true,
      prefix: marker,
      suffix: raw.slice(marker.length)
    };
  }

  /**
   * Triggers when the main TabView active index changes.
   * Ensures history is loaded if switching to the "All History" tab.
   */
  onMainTabChange(event: any) {
    const index = Number(event?.index ?? this.activeIndex ?? 0);
    this.activeIndex = index;
    if (index === this.historyTabIndex) {
      this.ensureHistoryLoadedForCurrentPatient();
    }
  }

  /**
   * Selects a record from the history list by its index.
   */
  selectHistoryRecord(index: number) {
    if (!Array.isArray(this.filteredRecords) || this.filteredRecords.length === 0) {
      this.selectedHistoryIndex = 0;
      return;
    }
    this.selectedHistoryIndex = Math.max(0, Math.min(index, this.filteredRecords.length - 1));
  }

  /**
   * Refreshes the patient history to page 1.
   */
  refreshHistory() {
    this.loadHistoryPage(1, false);
  }

  /**
   * Loads the next page of patient history if more pages are available.
   */
  loadMoreHistory() {
    if (this.historyLoading || this.historyLoadingMore || !this.historyHasMore) return;
    this.loadHistoryPage(Math.max(1, this.historyCurrentPage + 1), true);
  }

  /**
   * Checks if history is loaded for the current patient and loads it if not.
   */
  private ensureHistoryLoadedForCurrentPatient() {
    const patientId = Number(this.patient?.patient_id) || 0;
    if (!patientId) return;

    if (this.historyInitializedForPatientId === patientId && this.filteredRecords.length > 0) {
      return;
    }

    this.loadHistoryPage(1, false);
  }

  /**
   * Performs the paginated API call to fetch prescriptions/visits by patient ID.
   */
  private loadHistoryPage(page: number, append: boolean) {
    const patientId = Number(this.patient?.patient_id) || 0;
    if (!patientId) return;

    const requestToken = ++this.activeHistoryRequestToken;
    this.historyError = '';
    if (append) {
      this.historyLoadingMore = true;
    } else {
      this.historyLoading = true;
    }

    this.prescriptionsService.getPrescriptionsByPatientId(patientId, {
      page,
      per_page: this.historyPageSize
    }).subscribe({
      next: (res: any) => {
        if (requestToken !== this.activeHistoryRequestToken) return;

        const pageRecords = this.extractHistoryRecords(res);
        this.filteredRecords = append ? [...this.filteredRecords, ...pageRecords] : pageRecords;
        this.historyCurrentPage = this.extractHistoryPage(res) || page;
        this.historyTotalRecords = this.extractHistoryTotal(res, this.filteredRecords.length);
        this.historyHasMore = this.extractHistoryHasMore(res, pageRecords.length);
        this.historyInitializedForPatientId = patientId;

        if (!append || this.selectedHistoryIndex >= this.filteredRecords.length) {
          this.selectedHistoryIndex = 0;
        }

        // Recalculate personal dues based on updated records
        this.preconsultation.personal_dues = this.calculatePersonalDues(
          this.filteredRecords,
          this.preconsultation
        );
        this.refreshDoctorNotes(this.filteredRecords);
      },
      error: () => {
        if (requestToken !== this.activeHistoryRequestToken) return;
        this.historyError = 'Unable to load patient history right now.';
      },
      complete: () => {
        if (requestToken !== this.activeHistoryRequestToken) return;
        this.historyLoading = false;
        this.historyLoadingMore = false;
      }
    });
  }

  /**
   * Resets pagination state and variables for a new patient context.
   */
  private resetHistoryStateForPatient(patientId: number) {
    this.activeHistoryRequestToken++;
    this.filteredRecords = [];
    this.selectedHistoryIndex = 0;
    this.historyCurrentPage = 0;
    this.historyTotalRecords = 0;
    this.historyHasMore = false;
    this.historyLoading = false;
    this.historyLoadingMore = false;
    this.historyError = '';
    this.historyInitializedForPatientId = Number(patientId) || 0;
  }

  /**
   * Extracts history records from the response payload, parsing JSON arrays safely.
   */
  private extractHistoryRecords(res: any): any[] {
    const rows = Array.isArray(res?.data) ? res.data : [];
    return rows.map((record: any) => ({
      ...record,
      chief_complaints: record?.chief_complaints,
      suggested_reports: this.normalizeSuggestedReports(record?.suggested_reports),
    }));
  }

  parseToArray(val: any): any[] | null {
    if (!val) return null;
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') {
      try {
        const parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return parsed;
      } catch {
        return null;
      }
    }
    return null;
  }

  hasHistoryText(value: any): boolean {
    if (value === null || value === undefined) return false;
    if (Array.isArray(value)) return value.length > 0;
    return String(value).trim().length > 0;
  }

  hasHistoryClinicalContent(record: any): boolean {
    if (!record) return false;

    return (
      this.hasHistoryText(record.chief_complaints) ||
      this.hasHistoryText(record.suggested_reports) ||
      this.hasHistoryText(record.allergies) ||
      this.hasHistoryText(record.current_medications) ||
      this.hasHistoryText(record.personal_family_history) ||
      this.hasHistoryText(record.surgical_history) ||
      this.hasHistoryText(record.notes) ||
      this.hasHistoryText(record.special_instructions)
    );
  }

  hasHistoryVitals(record: any): boolean {
    if (!record) return false;

    return [
      record.blood_pressure,
      record.pulse_rate,
      record.temperature,
      record.weight,
      record.height,
      record.fasting_blood_sugar,
      record.blood_oxygen,
    ].some((value) => value !== null && value !== undefined && String(value).trim() !== '');
  }

  private normalizeSuggestedReports(raw: any): string[] {
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw.map((item) => String(item ?? '').trim()).filter(Boolean);
    }

    if (typeof raw === 'string') {
      const plain = raw.trim();
      if (!plain) return [];

      try {
        const parsed = JSON.parse(plain);
        if (Array.isArray(parsed)) {
          return parsed.map((item) => String(item ?? '').trim()).filter(Boolean);
        }
      } catch {
        // fall through to plain-text parsing
      }

      return plain
        .split(/[\n,]+/)
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return [];
  }

  /**
   * Extracts current page index from the paginated API response.
   */
  private extractHistoryPage(res: any): number {
    return Number(res?.pagination?.page || 0) || 0;
  }

  /**
   * Extracts total records count from the paginated API response.
   */
  private extractHistoryTotal(res: any, fallback: number): number {
    const total = Number(res?.pagination?.total ?? 0);
    if (Number.isFinite(total) && total > 0) return total;
    return fallback;
  }

  /**
   * Determines if more pages exist in the API history stream.
   */
  private extractHistoryHasMore(res: any, latestChunkLength: number): boolean {
    if (typeof res?.pagination?.has_more === 'boolean') {
      return res.pagination.has_more;
    }
    return latestChunkLength >= this.historyPageSize;
  }

  /**
   * Safely parses values that might be a JSON-encoded string or an object/array.
   */
  safeParse(value: any) {
    try {
      return typeof value === 'string' ? JSON.parse(value) : value || [];
    } catch {
      return [];
    }
  }

  addComplaintTag(tag: any) {
    const exists = (this.complaintTags as any[]).some(
      (c: any) => (c.chief_complaint ?? c).toLowerCase() ===
                  (tag.chief_complaint ?? tag).toLowerCase()
    );

    if (!exists) {
      (this.complaintTags as any[]).push(tag);
    }

    this.preconsultation.chief_complaints = '';
    this.filteredComplaints = [];
  }

  getAppointmentClass(type: string) {
    switch (this.normalizeAppointmentType(type)) {
      case 'new':
        return 'apt-new';
      case 'follow_up':
        return 'apt-followup';
      case 'case':
        return 'apt-case';
      default:
        return 'apt-default';
    }
  }

  getModernStatusColorClass(item: any): string {
    const s = String(item?.status || '').toLowerCase();
    if (s === 'scheduled' || s === 'pending') return 'border-blue';
    if (s === 'assistant_doctor') return 'border-purple';
    if (s === 'assistant_doctor_done') return 'border-teal';
    if (s === 'doctor') return 'border-green';
    if (s === 'medicine' || s === 'medicine_scheduled') return 'border-orange';
    if (s === 'reception' || s === 'receptionist') return 'border-cyan';
    if (s === 'completed') return 'border-gray';
    return 'border-gray';
  }

  getWaitTimeColorClass(label: string): string {
    if (!label) return 'text-muted';
    if (label.includes('In ') || label.includes('Just now')) return 'text-muted';
    const matchMins = label.match(/Waiting (\d+)m/);
    const matchHours = label.match(/Waiting (\d+)h/);
    if (matchHours) return 'text-danger fw-bolder';
    if (matchMins) {
      const mins = parseInt(matchMins[1], 10);
      if (mins < 15) return 'text-muted';
      if (mins < 30) return 'text-warning fw-semibold';
      return 'text-danger fw-semibold';
    }
    return 'text-muted';
  }

  getWaitTimeLabel(createdAt: string): string {
    if (!createdAt) return '';
    const now = new Date();

    // Check if it looks like a time-only string (fallback)
    if (createdAt.length <= 8 && createdAt.includes(':')) {
      const timeParts = createdAt.split(':');
      if (timeParts.length < 2) return '';
      const aptTime = new Date();
      aptTime.setHours(parseInt(timeParts[0], 10), parseInt(timeParts[1], 10), 0, 0);
      createdAt = aptTime.toISOString();
    }

    const aptTime = new Date(createdAt);
    if (isNaN(aptTime.getTime())) return '';

    const diffMs = now.getTime() - aptTime.getTime();
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 0) {
      return `In ${Math.abs(diffMins)}m`;
    }
    if (diffMins === 0) {
      return 'Just now';
    }
    if (diffMins < 60) {
      return `Waiting ${diffMins}m`;
    }
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return `Waiting ${hours}h ${mins}m`;
  }

  getQueueLifecycleLabel(item: any): string {
    const s = String(item?.status || '').toLowerCase();
    if (s === 'scheduled' || s === 'pending') return 'Scheduled';
    if (s === 'assistant_doctor') return 'Asst. Dr. Consulting';
    if (s === 'assistant_doctor_done') return 'Assistant Doctor Done';
    if (s === 'doctor') return 'In Consultation';
    if (s === 'medicine' || s === 'medicine_scheduled') return 'Pharmacy';
    if (s === 'reception' || s === 'receptionist') return 'Reception';
    if (s === 'completed') return 'Completed';
    return 'Waiting';
  }
}


